import { Company, User } from "src/api-service";
import { AppError } from "../app-store-error.types";

// **************************************************************************
// USER CONTEXT - Merged User + selectedCompany for component convenience
// **************************************************************************
export type UserContext = User & { selectedCompany: Company };

// **************************************************************************
// USER STATE (composition)
// **************************************************************************
export interface UserState {
    user: User | null;
    selectedCompany: Company | null;
    loading: boolean;
    error: AppError | null;
}

export const initialUserState: UserState = {
    user: null,
    selectedCompany: null,
    loading: true,
    error: null,
};
